import React from 'react';
import styles from './HeadlineSection.module.scss';

interface HeadlineSectionProps {
  firstSlot: string;
  secondSlot: string;
  thirdSlot: string;
}

const HeadlineSection = ({
  firstSlot,
  secondSlot,
  thirdSlot,
}: HeadlineSectionProps) => {
  return (
    <div className={styles.wrapper}>
      <h3>{firstSlot}</h3>
      <h3>{secondSlot}</h3>
      <h3>{thirdSlot}</h3>
    </div>
  );
};

export { HeadlineSection };
export type { HeadlineSectionProps };
